module.exports = "https://secnetweb.ksyun.com/KEC/ksc-node-kvm/assets/iconfont.577bd19ccdc80046138cb11abf8d5cbe.woff";